import React from "react";
import FeatureList from "../FeatureList";

const HomePage: React.FC = () => {
  return (
    <div>
      <div className="text-primary glow-text" style={{ fontSize: "32px", marginBottom: "20px", marginTop: 0, marginLeft: 0, marginRight: 0, fontWeight: "600" }}>
        Host 应用
      </div>
      <FeatureList />
    </div>
  );
};

export default HomePage;
